import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createStaticVNode as _createStaticVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-43da6bb4")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 mb-xl-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-1" }, " Determine how much electricity you have consumed in the past and its associated cost and emissions output. ")
], -1)
const _hoisted_2 = { class: "card p-4" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"row col-md-12\" data-v-43da6bb4><div class=\"col-md-3\" data-v-43da6bb4><h6 style=\"color:rgb(46, 49, 146);font-size:medium;\" for=\"FromDate\" data-v-43da6bb4> From </h6></div><div class=\"col-md-3\" data-v-43da6bb4><h6 style=\"color:rgb(46, 49, 146);font-size:medium;\" for=\"FromDate\" data-v-43da6bb4> To </h6></div><div class=\"col-md-3\" data-v-43da6bb4><h6 style=\"color:rgb(46, 49, 146);font-size:medium;\" for=\"FromDate\" data-v-43da6bb4> Enter Location </h6></div></div>", 1)
const _hoisted_4 = { class: "row col-md-12" }
const _hoisted_5 = { class: "col-md-3" }
const _hoisted_6 = { class: "col-md-3" }
const _hoisted_7 = { class: "col-md-3" }
const _hoisted_8 = { class: "col-md-1" }
const _hoisted_9 = {
  class: "row col-md-12 pt-4",
  style: {"text-align":"center"}
}
const _hoisted_10 = { class: "col-lg-4 col-md-4 col-sm-6 col-xs-12" }
const _hoisted_11 = {
  class: "dashboard-stat dashboard-stat-v2",
  style: {"background-color":"rgb(46, 49, 146)"},
  href: "#"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "visual" }, null, -1)
const _hoisted_13 = { class: "details" }
const _hoisted_14 = { class: "number" }
const _hoisted_15 = {
  "data-counter": "counterup",
  id: "lblTotalConsum",
  style: {"color":"white"}
}
const _hoisted_16 = {
  class: "p-3",
  style: {"color":"white","font-size":"30px","font-family":"'Arial'","font-weight":"80"}
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", {
  class: "desc",
  style: {"color":"white","font-weight":"Normal !important"}
}, " Consumption (kWh) ", -1)
const _hoisted_18 = { class: "col-lg-4 col-md-4 col-sm-6 col-xs-12" }
const _hoisted_19 = {
  class: "dashboard-stat dashboard-stat-v2",
  style: {"background-color":"rgb(237, 28, 36)"},
  href: "#"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "visual" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-shopping-cart fa-3x" })
], -1)
const _hoisted_21 = { class: "details" }
const _hoisted_22 = { class: "number" }
const _hoisted_23 = {
  "data-counter": "counterup",
  id: "lblTotalCost",
  style: {"color":"white"}
}
const _hoisted_24 = {
  class: "p-3",
  style: {"color":"white","font-size":"30px","font-family":"'Arial'","font-weight":"80"}
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  class: "desc",
  style: {"color":"white","font-weight":"Normal"}
}, " Cost (£) ", -1)
const _hoisted_26 = { class: "col-lg-4 col-md-4 col-sm-6 col-xs-12" }
const _hoisted_27 = {
  class: "dashboard-stat dashboard-stat-v2",
  style: {"background-color":"rgb(0, 134, 170)"},
  href: "#"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "visual" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chart-bar fa-3x" })
], -1)
const _hoisted_29 = { class: "details" }
const _hoisted_30 = { class: "number" }
const _hoisted_31 = {
  "data-counter": "counterup",
  id: "lblTotalCo2",
  style: {"color":"white"}
}
const _hoisted_32 = {
  class: "p-3",
  style: {"color":"white","font-size":"30px","font-family":"'Arial'","font-weight":"80"}
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", {
  class: "desc",
  style: {"color":"white","font-weight":"normal"}
}, [
  /*#__PURE__*/_createTextVNode(" CO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode(" (kgCO"),
  /*#__PURE__*/_createElementVNode("sub", null, "2"),
  /*#__PURE__*/_createTextVNode("e) ")
], -1)
const _hoisted_34 = { class: "card mb-xl-1" }
const _hoisted_35 = { class: "card-body" }
const _hoisted_36 = {
  class: "d-flex overflow-auto h-20x",
  style: {"float":"right"}
}
const _hoisted_37 = { id: "container" }
const _hoisted_38 = { class: "tabs" }
const _hoisted_39 = { class: "tab" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-box card-label",
  style: {"cursor":"pointer"}
}, " Graph(s) ", -1)
const _hoisted_41 = { class: "tab" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-box card-label",
  style: {"cursor":"pointer"}
}, " Table ", -1)
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  class: "card mb-5 mb-xl-5",
  id: "kt_profile_details_view"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header cursor-pointer",
  style: {"float":"right !important"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0 row col-md-5" }, [
    /*#__PURE__*/_createElementVNode("h6", { class: "fw-bolder m-0" }, [
      /*#__PURE__*/_createElementVNode("i", { class: "bi-bar-chart-fill text-danger p-3" }),
      /*#__PURE__*/_createTextVNode(" Historic Consumption, Cost and CO2 - Electricity ")
    ])
  ])
], -1)
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { id: "chart" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = {
  key: 2,
  style: {},
  id: "loadingDiv"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "loader" }, "Loading...", -1)
const _hoisted_52 = [
  _hoisted_51
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_TableTab = _resolveComponent("TableTab")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.fromDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.fromDate = $event)),
            type: "date",
            format: "DD/MM/YYYY",
            "disabled-date": _ctx.disableDates
          }, null, 8, ["modelValue", "disabled-date"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.toDate,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.toDate = $event)),
            type: "date",
            format: "DD/MM/YYYY",
            "disabled-date": _ctx.disableDates
          }, null, 8, ["modelValue", "disabled-date"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _withDirectives(_createElementVNode("input", {
            type: "search",
            style: {"color":"rgb(46, 49, 146)"},
            class: "card-label input_ p-3",
            placeholder: "--- Leave this blank to list all sites ---",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchInput = $event)),
            onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.searchEvent && _ctx.searchEvent(...args)))
          }, null, 544), [
            [_vModelText, _ctx.searchInput]
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.getContent()))
          }, " View ")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("a", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.$filters.StringFormat(_ctx.sumKwh)), 1)
              ])
            ]),
            _hoisted_17
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("a", _hoisted_19, [
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, [
                _createElementVNode("h4", _hoisted_24, _toDisplayString(_ctx.sumCost), 1)
              ])
            ]),
            _hoisted_25
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("a", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, [
                _createElementVNode("h4", _hoisted_32, _toDisplayString(_ctx.$filters.StringFormat(_ctx.sumCo2)), 1)
              ])
            ]),
            _hoisted_33
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", _hoisted_39, [
                _createElementVNode("input", {
                  type: "radio",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.openAssetAddition && _ctx.openAssetAddition(...args))),
                  name: "tab-input",
                  class: "tab-input"
                }),
                _hoisted_40
              ]),
              _createElementVNode("label", _hoisted_41, [
                _createElementVNode("input", {
                  type: "radio",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openAssetRemoval && _ctx.openAssetRemoval(...args))),
                  name: "tab-input",
                  class: "tab-input"
                }),
                _hoisted_42
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.addition)
      ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _hoisted_45,
            (!_ctx.isViewClicked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, " Please select date and click on the view to see the Graph "))
              : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createVNode(_component_apexchart, {
                      type: "line",
                      height: "350",
                      options: _ctx.eboptions.chartOptions,
                      series: _ctx.series
                    }, null, 8, ["options", "series"])
                  ])
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.removal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          _createVNode(_component_TableTab, {
            "table-data": _ctx.tableValues,
            "table-header": _ctx.OriginalTableHeaders,
            "enable-items-per-page-dropdown": true,
            selectedType: _ctx.colnames,
            pagetitle: _ctx.pageheader,
            downloadUrl: _ctx.downloadurl,
            downloadprops: _ctx.downloadprops,
            isTemplateDownload: true
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.colnames, (slot) => {
              return {
                name: `cell-${slot}`,
                fn: _withCtx(({ row: customer }) => [
                  _createTextVNode(_toDisplayString(customer[slot]), 1)
                ])
              }
            })
          ]), 1032, ["table-data", "table-header", "selectedType", "pagetitle", "downloadUrl", "downloadprops"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_50, _hoisted_52))
      : _createCommentVNode("", true)
  ], 64))
}